<template>
    <div class="transaction-details-amount-form-modal">
        <r-button :disabled="isProcessing || !maxAmount" @click="showModal">{{titleCapitalized}}</r-button>
        <v-modal :title="titleCapitalized" v-if="isModalVisible" @close="closeModal" @submit="inputAmount && submit()">
            <template slot="content">
                <v-error-messages :has-frontend-errors="$v.$error" class="stack-l">
                     <li class="list-item" v-if="$v.inputAmount.$error">
                         You must enter an amount greater than zero and lower than or equal to the total of {{this.maxAmount}}
                     </li>
                </v-error-messages>
                 <div v-if="$slots.message" class="stack-m">
                    <slot name="message"/>
                 </div>
                <r-input :validate="$v.inputAmount" :leftLabel="inputSign" :helpText="inputHelpText" v-model="inputAmount"/>
            </template>
            <template slot="actions">
                <r-button type="primary" :disabled="!inputAmount || $v.inputAmount.$error" @click="submit">Apply</r-button>
            </template>
        </v-modal>
    </div>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import CURRENCIES from '@/data/currencies';
    import VErrorMessages from '@/components/form/v-error-messages';
    import _ from '@/common/helpers/index';
    import {maxValue, required} from 'vuelidate/lib/validators';
    import currencyValue from '@/components/vuelidate/validators/currency';

    export default {
        name: 'amount-form-modal',
        components: {
            VErrorMessages,
            vModal,
        },
        props: {
            title: {
                type: String,
                default: 'Amount',
            },
            maxAmount: {
                type: [String, Number],
                default: 0,
            },
            currencyCode: {
                type: String,
                default: 'USD',
            },
            isProcessing: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        computed: {
            inputSign() {
                const foundCurrency = CURRENCIES.find(
                    currency => currency.iso === this.currencyCode,
                );
                return foundCurrency ? foundCurrency.sign : this.currencyCode;
            },
            inputHelpText() {
                return `of a maximum of $${this.maxAmount}`;
            },
            titleCapitalized() {
                return _.capitalize(this.title);
            },
        },
        data() {
            return {
                isModalVisible: false,
                inputAmount: 0,
            };
        },
        watch: {
            inputAmount(val) {
                // TODO temporary solution
                if (/\d,\d{3}(\.\d{1,2})?$/g.test(val)) {
                    this.inputAmount = val.replace(/,/g, '');
                }
            },
        },
        validations() {
            return {
                inputAmount: {
                    required,
                    currency: currencyValue,
                    maxValue: maxValue(this.maxAmount),
                },
            };
        },
        methods: {
            showModal() {
                this.isModalVisible = true;
                this.inputAmount = this.maxAmount;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.$emit('submit', this.inputAmount);
                    this.closeModal();
                }
            },
        },
    };
</script>
